export class BelongingGroupResource{
  id: number;
  description: string;
}
